import CommandsApi from 'client/api/v2/CommandsApi';
import SystemApi from 'client/api/v2/SystemApi';
import SystemGroupApi from 'client/api/v2/SystemGroupApi';
import UserApi from 'client/api/v2/UserApi';
import UserGroupApi from 'client/api/v2/UserGroupApi';

export const baseUrl = '/api/v2/directoryinsights/reports';
export const exportFailureMessage = 'There was a problem exporting report.';
export const exportSuccessMessage = 'Successfully exported report.';

export const FilterTypes = {
  commands: 'commands',
  deviceGroups: 'deviceGroups',
  devices: 'devices',
  userGroups: 'userGroups',
  users: 'users',
};

export const FilterApiRefs = {
  [FilterTypes.commands]: CommandsApi,
  [FilterTypes.deviceGroups]: SystemGroupApi,
  [FilterTypes.devices]: SystemApi,
  [FilterTypes.userGroups]: UserGroupApi,
  [FilterTypes.users]: UserApi,
};

export const FilterAttributes = {
  [FilterTypes.commands]: {
    name: 'name',
    value: '_id',
  },
  [FilterTypes.deviceGroups]: {
    name: 'name',
    value: 'id',
  },
  [FilterTypes.devices]: {
    name: 'displayName',
    value: 'id',
  },
  [FilterTypes.userGroups]: {
    name: 'name',
    value: 'id',
  },
  [FilterTypes.users]: {
    name: '', // Leave empty string. firstname + lastname gets concated
    value: '_id',
  },
};

// This contains references to filters that must be disabled when the filter is applied
// ie: when device groups filter applied, disable devices filter
export const FilterDisableRefs = {
  [FilterTypes.commands]: [],
  [FilterTypes.deviceGroups]: [FilterTypes.devices],
  [FilterTypes.devices]: [FilterTypes.deviceGroups],
  [FilterTypes.userGroups]: [FilterTypes.users],
  [FilterTypes.users]: [FilterTypes.userGroups],
};

export const FilterTitles = {
  [FilterTypes.commands]: 'Commands',
  [FilterTypes.deviceGroups]: 'Device Groups',
  [FilterTypes.devices]: 'Devices',
  [FilterTypes.userGroups]: 'User Groups',
  [FilterTypes.users]: 'Users',
};

export const ReportDataFields = {
  type: 'type',
  parameters: 'parameters',
  requester_email: 'requester_email',
  created_at: 'created_at',
  updated_at: 'updated_at',
  status: 'status',
  expiration: 'expiration',
};
export const ReportSortFields = {
  name: 'REPORT',
  [ReportDataFields.type]: 'TYPE',
  [ReportDataFields.requester_email]: 'REQUESTER_EMAIL',
  [ReportDataFields.created_at]: 'CREATED_AT',
  [ReportDataFields.updated_at]: 'UPDATED_AT',
  [ReportDataFields.expiration]: 'EXPIRATION',
  [ReportDataFields.status]: 'STATUS',
};

export const ReportTypeConsts = {
  'users-to-devices': 'Users to Devices',
  'users-to-directories': 'Users to Directories',
  'users-to-ldap-servers': 'Users to LDAP Servers',
  'users-to-radius-servers': 'Users to RADIUS Servers',
  'users-to-user-groups': 'Users to User Groups',
  'browser-patch-policy': 'Browser Patch Management Policy',
  'os-patch-policy': 'OS Patch Management Policy',
  'users-to-sso-applications': 'Users to SSO Applications',
  // To be removed in RR-451. Currently we need to support the format below,
  // but we will be changing it to 'users-to-sso-applications'.
  // https://jumpcloud.atlassian.net/browse/RR-451
  'users-to-sso': 'Users to SSO Applications',
  // To be fixed in RR-451: convert user to device reports to
  // kebab-case after migration to streaming.
  // https://jumpcloud.atlassian.net/browse/RR-451
  USER_TO_DEVICES: 'Users to Devices',
  USER_TO_DIRECTORIES: 'Users to Directories',
  USER_TO_LDAP: 'Users to LDAP Servers',
  USER_TO_RADIUS: 'Users to RADIUS Servers',
};

export const ReportStatusConsts = {
  pending: 'PENDING',
  inProgress: 'IN_PROGRESS',
  failed: 'FAILED',
  completed: 'COMPLETED',
  deleted: 'DELETED',
};

export const ReportStatusDisplayConsts = {
  PENDING: 'Pending',
  IN_PROGRESS: 'In progress',
  FAILED: 'Failed',
  COMPLETED: 'Completed',
  DELETED: 'Deleted',
};

export const ReportMenuLabels = {
  deviceReports: 'Device Reports',
  userToResourceReports: 'Users to Resources Reports',
};

export const ReportListTableColumnConsts = {
  actions: 'Actions',
  [ReportDataFields.type]: 'Report Name',
  [ReportDataFields.parameters]: 'Filters',
  [ReportDataFields.requester_email]: 'Created by',
  [ReportDataFields.created_at]: 'Created at',
  [ReportDataFields.status]: 'Status',
  [ReportDataFields.expiration]: 'Expiration',
};
